import React, { FC } from 'react';
import { BoxProps } from '@mui/material';
import classNames from 'classnames';
import { getRelativeTime } from '../../../shared/utils/string/time';
import ThreeDotIcon from '../../../components/icon/ThreeDot';
import { SiteDesign } from '../../../shared/types/site/design';
import { siteUrl } from '../../../shared/url';

interface SiteCardProps extends BoxProps {
    siteDesign: SiteDesign;
    onClickMoreAction: (site: SiteDesign) => void;
    onClickThumbnail: (siteId: number) => void;
    showActions?: boolean;
}

const SiteCard: FC<SiteCardProps> = ({ siteDesign, showActions = true, onClickMoreAction, onClickThumbnail }) => {
    const appUrl = siteUrl();
    return (
        <div className="rounded-8 bg-white overflow-hidden">
            <div className="relative">
                <img
                    src={siteDesign.thumbnail ? siteDesign.thumbnail : appUrl + '/images/Site-Thumbnail.jpg'}
                    className="h-150 w-full object-cover object-top cursor-pointer"
                />
                <div
                    onClick={() => onClickThumbnail(siteDesign.accountId)}
                    className="cursor-pointer absolute w-full h-full left-0 top-0 bg-gradient-360 z-1"
                />
                <div className="absolute top-6 right-8 flex items-stretch justify-end z-10">
                    <div
                        className={classNames({
                            'text-10 font-semibold leading-12 p-6 rounded mr-6': true,
                            'bg-success': siteDesign.publishedAt,
                            'bg-warning': !siteDesign.publishedAt,
                        })}
                    >
                        {siteDesign.publishedAt ? 'LIVE' : 'DRAFT'}
                    </div>
                    {showActions && (
                        <div
                            className="w-24 h-24 bg-white rounded text-3 flex items-center justify-center cursor-pointer"
                            onClick={() => onClickMoreAction(siteDesign)}
                        >
                            <ThreeDotIcon />
                        </div>
                    )}
                </div>
            </div>
            <div className="px-10 pb-10 pt-6" onClick={() => onClickThumbnail(siteDesign.accountId)}>
                <p className="text-14 font-semibold mb-3 whitespace-nowrap overflow-hidden text-ellipsis">
                    {siteDesign.name}
                </p>
                <p className="text-8 text-primary-80">
                    {siteDesign.updatedAt
                        ? `Last updated ${getRelativeTime(siteDesign.updatedAt)}.`
                        : `Created ${getRelativeTime(siteDesign.createdAt)}.`}
                </p>
            </div>
        </div>
    );
};

export default SiteCard;
